import { render, staticRenderFns } from "./AddNewTemplateModal.vue?vue&type=template&id=0deddbaa"
import script from "./AddNewTemplateModal.vue?vue&type=script&lang=js"
export * from "./AddNewTemplateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0deddbaa')) {
      api.createRecord('0deddbaa', component.options)
    } else {
      api.reload('0deddbaa', component.options)
    }
    module.hot.accept("./AddNewTemplateModal.vue?vue&type=template&id=0deddbaa", function () {
      api.rerender('0deddbaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layoutDesigner/editor/settingPanel/playlist/AddNewTemplateModal.vue"
export default component.exports